import { Fragment, useContext } from "react";
import { Outlet } from "react-router-dom";

import CartIcon from "../../components/cart-icon/cart-icon.component";
import CartDropdown from "../../components/cart-dropdown/cart-dropdown.component";

import { UserContext } from "../../contexts/user.context";
import { CartContext } from "../../contexts/cart.context";

import { ReactComponent as HomeLogo } from "../../assets/logoCopy.svg";
import { signOutUser } from "../../utils/firebase/firebase.utils";

import {
  NavigationContainer,
  NavLinks,
  NavLink,
  LogoContainer,
  NavBar,
} from "./navigation.styles";
import { toast } from "react-toastify";

const Navigation = () => {
  const { currentUser } = useContext(UserContext);
  const { isCartOpen } = useContext(CartContext);

  const signInOuthandler = () => {
    signOutUser();
    try {
      toast.info("You have successfully logged out.");
      localStorage.removeItem("toast_user_logged_in");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Fragment>
      <NavBar>
        <NavigationContainer>
          <LogoContainer to="/">
            <HomeLogo className="logo" />
          </LogoContainer>
          <NavLinks>
            <NavLink to="/">HOME</NavLink>
            <NavLink to="/shop">SHOP</NavLink>

            {currentUser ? (
              <NavLink as="span" onClick={signInOuthandler}>
                SIGN OUT
              </NavLink>
            ) : (
              <NavLink to="/auth">SIGN IN</NavLink>
            )}
            <CartIcon />
          </NavLinks>
          {isCartOpen && <CartDropdown />}
        </NavigationContainer>
      </NavBar>

      <Outlet />
    </Fragment>
  );
};

export default Navigation;
